import loadable from '@loadable/component'
import format_BusQueryDate from '../utils/QueryDateFormat';
import format_dateObj from '../utils/FormatDateObj';
import getDateObj from '../utils/GetDateObj';
import dateformat from 'dateformat';
import { getRoutePageData, getCategoryData } from '../SEOContainer/RoutePage/utils'
import { updateRouteData, updateSRPBusData } from '../SEOContainer/RoutePage/redux/actions';
import { updateJourneyParams as updateJourneyParamsSEO } from '../SEOContainer/Common/redux/actions'
import { ISRPBusData } from '../SEOContainer/RoutePage/redux/validations'
import { redisConfig } from './../config/infraConfig';
import { pushDataToNewrelicFromServer, getRouteClientDumpData, getOperatorClientDumpData, getCityClientDumpData, getCachingKey } from './../SEOContainer/Common/utils';
import { getOperatorPageData, getOperatorKey } from './../SEOContainer/OperatorPage/utils';
import { updateOperatorData } from './../SEOContainer/OperatorPage/redux/actions';
import { getCityPageData, getCityKey } from './../SEOContainer/CityPage/utils';
import { updateCityData } from './../SEOContainer/CityPage/redux/actions';
import { getOperatorTypePageData } from "../SEOContainer/OperatorTypeRespPage/utils";
import { getRouteOperatorTypePageData } from '../SEOContainer/RouteOperatorTypeRespPage/utils';
import { getRouteCategoryPageData } from './../SEOContainer/RoutePage/RouteCategoryPage/utils'
import { getRouteOperatorKey, getRouteOperatorPageData } from './../SEOContainer/RoutePage/RouteOperatorPage/utils'
import { getCityCategoryKey, getCityCategoryPageData } from './../SEOContainer/CityCategoryPage/utils'
import { redirection } from './redirectionController';
import { getCityDirPageData, getDirKey, getOperatorDirPageData, getRoutesDirPageData } from '../SEOContainer/DirectoryPage/utils';
import { updateDirectoryData } from '../SEOContainer/DirectoryPage/redux/actions';
import { CITY_DIRECTORY_PAGE, CITY_DIRECTORY_URL, OPERATOR_DIRECTORY_PAGE, OPERATOR_DIRECTORY_URL, ROUTES_DIRECTORY_PAGE, ROUTES_DIRECTORY_URL } from '../SEOContainer/DirectoryPage/redux/constants';
import { getCategoryPageData } from '../SEOContainer/CategoryPage/utils';
import { updateCategoryData } from '../SEOContainer/CategoryPage/redux/actions';
import { getStandPageData } from '../SEOContainer/StandPage/utils';
import { CATEGORY_URL } from '../SEOContainer/CategoryPage/redux/constants';
import { STAND_URL } from '../SEOContainer/StandPage/redux/constants';
import { updateStandData } from '../SEOContainer/StandPage/redux/actions';

const RouteRespPage = loadable(() => import(/* webpackChunkName: "RouteRespPage" */ './../SEOContainer/RouteRespPage/RouteRespPage'))
const OperatorRespPage = loadable(() => import(/* webpackChunkName: "OperatorRespPage" */ './../SEOContainer/OperatorRespPage/OperatorRespPage'));
const OperatorTypeRespPage = loadable(() => import(/* webpackChunkName: "OperatorRespPage" */ '../SEOContainer/OperatorTypeRespPage'));
const CityRespPage = loadable(() => import(/* webpackChunkName: "cityRespPage" */ './../SEOContainer/CityRespPage/CityRespPage'))
const DirectoryPage = loadable(() => import(/* webpackChunkName: "DirectoryPage" */ '../SEOContainer/DirectoryPage/DirectoryPage'))
const CityCategoryRespPage = loadable(() => import(/* webpackChunkName: "cityCategoryRespPage" */ './../SEOContainer/CityCategoryRespPage/CityCategoryRespPage'))
const RouteCategoryRespPage = loadable(() => import(/* webpackChunkName: "RouteCategoryRespPage" */ './../SEOContainer/RouteCategoryRespPage/RouteCategoryRespPage'))
const RouteOperatorRespPage = loadable(() => import(/* webpackChunkName: "RouteOperatorRespPage" */ './../SEOContainer/RouteOperatorRespPage/RouteOperatorRespPage'))
const RouteOperatorTypeRespPage = loadable(() => import(/* webpackChunkName: "RouteOperatorTypeRespPage" */ '../SEOContainer/RouteOperatorTypeRespPage/RouteOperatorTypePage'))
const CategoryPage = loadable(() => import(/* webpackChunkName: "CategoryPage" */ '../SEOContainer/CategoryPage/CategoryPage'))
const StandPage = loadable(() => import(/* webpackChunkName: "StandPage" */ '../SEOContainer/StandPage/StandPage'))

const CityGIRespPage = loadable(() => import(/* webpackChunkName: "CityGIRespPage" */ './../SEOContainer/CityGIRespPage/CityGIRespPage'))
const RouteGIRespPage = loadable(() => import(/* webpackChunkName: "RouteGIRespPage" */ './../SEOContainer/RouteGIRespPage/RouteGIRespPage'))

export default [
  {
    path: [
    '/bus/:src-to-:dest-bus-tickets/',
    ],
    component: RouteRespPage,
    key: 'RoutePage',
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: params.src,
        dest: params.dest,
        src_vid: '',
        dest_vid: '',
        doj: '',
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: ''
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.routePage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const journeyType: string = commonState.journeyType;
      const key = `${commonState.src}-to-${commonState.dest}-bus-tickets`

      let data = await getRoutePageData({ src: commonState.src, dest: commonState.dest });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateRouteData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getRouteClientDumpData(commonState.src, commonState.dest, key)
        pushDataToNewrelicFromServer(`mBusRoutePage=true&value=nodata&key=${key}`);
      }

      if (data && data?.data && data?.data?.src_dump) {
        pushDataToNewrelicFromServer(`mBusRoutePage=true&value=dump&key=${key}`);
      }

      const { src, dest, dest_id, src_id, date } = data.data;
      let searchDateObj = {}
      let doj = null;

      const currentDateObj = format_dateObj({
        keyName: 'currentDate',
        value: dateformat(getDateObj(), 'yyyy-mm-dd')
      })

      if (date !== 'NA') {
        const queryDate = format_BusQueryDate(date);
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
      }
      if (date === 'NA' || searchDateObj['searchDateRaw'].getTime() <= currentDateObj['currentDateRaw'].getTime()) {
        doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
      }

      if (data && data.data && Object.keys(data.data).length && data.data.bus_data) {
        const {
          buses,
          operators,
          popular_filters,
          bp_dict,
          dp_dict,
          route_logic,
          ps
        } = data.data.bus_data as ISRPBusData;

        const {
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          amenities,
          operatorsList,
          popularFilters,
          isRouteEnable,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
        } = getCategoryData(operators, buses, journeyType, popular_filters, bp_dict, dp_dict, src_id, dest_id, route_logic);

        return [updateRouteData(data), updateJourneyParamsSEO({
          src: src,
          dest: dest,
          src_vid: src_id,
          dest_vid: dest_id,
          doj: doj,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: src,
          dest_name: dest
        }), updateSRPBusData({
          data: data.data.bus_data,
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          operatorsList,
          amenities,
          popularFilters,
          isRouteEnable,
          ps,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          dumpData: data.data?.src_dump,
          bpdpData: data.data.bp_dp_data && Object.keys(data.data.bp_dp_data).length ? data.data.bp_dp_data : {},
        })];
      }
    },
    criticalApiPreFetch: () => { },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => { },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    enableAdtech: true,
    toBeCached: true,
    enableVWO: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCachingKey(params.src, params.dest, "", "", "route")
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [
      '/bus/:operator-online-bus-booking-:bus_type?/',
    ],
    component: OperatorTypeRespPage,
    key: 'OperatorTypePage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: '',
        dest: '',
        src_vid: '',
        dest_vid: '',
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        bus_type: params.bus_type,
        operator_name: params.operator,
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // TODO to check for redirection
      const redirectUrl = redirection(state?.operatorPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { operator_name, bus_type } = commonState;

      let key = `${operator_name}-online-bus-booking-${bus_type}`;

      let data = await getOperatorTypePageData({
        operatorName: commonState.operator_name,
        bus_type: commonState.bus_type
      });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateOperatorData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getOperatorClientDumpData(operator_name, '', key);
        pushDataToNewrelicFromServer(`mBusOperatorTypePage=true&value=nodata&key=${key}`);
      }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateOperatorData(data)];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    disbaleExternalDependency: true,
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const key = getOperatorKey(params.operator, "", params.bus_type);
        return key
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [
      '/bus/:operator-bus-booking:operatorId?/',
    ],
    component: OperatorRespPage,
    key: 'OperatorPage',
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: '',
        dest: '',
        src_vid: '',
        dest_vid: '',
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        operator_name: params.operator,
        operator_id: params.operatorId || ''
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // TODO to check for redirection
      const redirectUrl = redirection(state?.operatorPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;

      const { operator_name, operator_id } = commonState;
      let key = `${operator_name}-bus-booking${operator_id}`;

      let data = await getOperatorPageData({
        operatorName: commonState.operator_name,
        operatorId: commonState.operator_id
      });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateOperatorData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getOperatorClientDumpData(operator_name, operator_id, key);
        pushDataToNewrelicFromServer(`mBusOperatorPage=true&value=nodata&key=${key}`);
      }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateOperatorData(data)];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    disbaleExternalDependency: true,
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const key = getOperatorKey(params.operator, params.operatorId);
        return key
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [
      '/bus/:city-bus-gi-buses/',
    ],
    component: CityGIRespPage,
    key: 'CityGIRespPage',
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: '',
        dest: params.city,
        src_vid: '',
        dest_vid: '',
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        cityName: params.city,
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // GI
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;

      const { cityName } = commonState;
      let key = `${cityName}-buses`;
      let data = await getCityPageData({ city: cityName });
      if (!data || !data.status || data.error) {
        data = getCityClientDumpData(cityName, key)
        pushDataToNewrelicFromServer(`mBusCityPage=true&value=nodata&key=${key}`);
      }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateCityData(data)];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: false,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: true,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const key = getCityKey(params.city, 'gi');
        return key
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [CITY_DIRECTORY_URL,],
    component: DirectoryPage,
    key: CITY_DIRECTORY_PAGE,
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      const pageNo = new URLSearchParams(searchString).get("pg");
      dispatch(updateJourneyParamsSEO({
        pageNumber: pageNo ?? 1,
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        dojObj: getDateObj(),
        pageType: CITY_DIRECTORY_PAGE,
      }))
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.DirectoryPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      let data = await getCityDirPageData({ page: commonState.pageNumber });

      // if (data && data?.data && data.data?.redirect_to) {
      //   return [updateDirectoryData(data)];
      // }
      // const key = CITY_DIRECTORY_PAGE;
      // if (!data || !data.status || data.error) {
      //   data = getCityClientDumpData(cityName, key)
      //   pushDataToNewrelicFromServer(`mBusDirectoryPage=true&value=nodata&key=${key}`);
      // }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateDirectoryData(data)];
      }
    },
    criticalApiPreFetch: () => { },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => { },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: true,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const pageNo = new URLSearchParams(searchString).get("pg");
        return getDirKey(pageNo, "city");
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [
      '/bus/:city-buses/',
    ],
    component: CityRespPage,
    key: 'CityRespPage',
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: '',
        dest: params.city,
        src_vid: '',
        dest_vid: '',
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        cityName: params.city,
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.cityPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { cityName } = commonState;
      const key = `${cityName}-buses`;

      let data = await getCityPageData({ city: cityName });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateCityData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getCityClientDumpData(cityName, key)
        pushDataToNewrelicFromServer(`mBusCityPage=true&value=nodata&key=${key}`);
      }

      let searchDateObj = {}

      if (data.data?.date) {
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(data.data.date) });
      }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateCityData(data), updateJourneyParamsSEO({
          src: "",
          dest: data.data.city_name,
          src_vid: "",
          dest_vid: data.data.city_vid,
          doj: data.data.date,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: "",
          dest_name: data.data.city_name
        })];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: true,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCityKey(params.city, "gikey");
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [
      '/bus/:src-to-:dest-:type?-bus-ticket-booking/',
    ],
    component: RouteCategoryRespPage,
    key: 'RouteCategoryRespPage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: params.src,
        dest: params.dest,
        src_vid: '',
        dest_vid: '',
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: params.src,
        dest_name: params.dest,
        filterStr: params.type
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.routePage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { filterStr, journeyType } = commonState;
      const key = `${commonState.src}-to-${commonState.dest}-${filterStr}-bus-ticket-booking`;

      let data = await getRouteCategoryPageData({ src: commonState.src, dest: commonState.dest, slug: filterStr });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateRouteData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getRouteClientDumpData(commonState.src, commonState.dest, key)
        pushDataToNewrelicFromServer(`mBusRouteCategoryPage=true&value=nodata&key=${key}`);
      }

      const { src, dest, dest_id, src_id, date } = data.data;
      let searchDateObj = {}
      let doj = null;

      const currentDateObj = format_dateObj({
        keyName: 'currentDate',
        value: dateformat(getDateObj(), 'yyyy-mm-dd')
      })

      if (date !== 'NA') {
        const queryDate = format_BusQueryDate(date);
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
      }

      if (date === 'NA' || searchDateObj['searchDateRaw'].getTime() <= currentDateObj['currentDateRaw'].getTime()) {
        doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
      }

      if (data && data.data && Object.keys(data.data).length && data.data.bus_data) {
        const {
          buses,
          operators,
          popular_filters,
          bp_dict,
          dp_dict,
          route_logic,
          ps,
          other_buses
        } = data.data.bus_data as ISRPBusData;
        const {
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          amenities,
          operatorsList,
          popularFilters,
          isRouteEnable,
          otherPrivateAvailableBuses,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          primaryFiltersInfo

        } = getCategoryData(operators, buses, journeyType, popular_filters, bp_dict, dp_dict, src_id, dest_id, route_logic, other_buses);

        if (data.data && data.data?.src_dump) {
          pushDataToNewrelicFromServer(`mBusRouteCategoryPage=true&value=dump&key=${src}_${dest}`);
        }

        return [updateRouteData(data), updateJourneyParamsSEO({
          src: src,
          dest: dest,
          src_vid: src_id,
          dest_vid: dest_id,
          doj: doj,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: src,
          dest_name: dest,
          filterStr: ''
        }), updateSRPBusData({
          data: data.data.bus_data,
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          operatorsList,
          amenities,
          popularFilters,
          isRouteEnable,
          ps,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          primaryFiltersInfo,
          dumpData: data.data?.src_dump,
          bpdpData: data.data.bp_dp_data && Object.keys(data.data.bp_dp_data).length ? data.data.bp_dp_data : {},
          otherPrivateAvailableBuses
        })];
      }

    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: false,
    enableAdtech: true,
    enableVWO: false,
    mongoCache: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCachingKey(params.src, params.dest, params.type, '');
      },
      mongoOptions: {
        baseURL: `${__ENV_CONFIG__.__DEPOT__}/apis/v1/seo_cache_data/`,
        template: 'sector_category',
        flavour: 'mobile'
      }
    },
  },
  {
    path: [
      '/bus/:operator-buses-:bus_type-from-:src-to-:dest-online-bus-:operatorId?/',
    ],
    component: RouteOperatorTypeRespPage,
    key: 'RouteOperatorTypeRespPage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      const { src, dest, operator, operatorId, bus_type } = params;
      dispatch(updateJourneyParamsSEO({
        src: src,
        dest: dest,
        src_vid: '',
        dest_vid: '',
        doj: '',
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        operator_name: operator,
        bus_type: bus_type,
        operator_id: operatorId.replace("-", "")
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.routePage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const journeyType: string = commonState.journeyType;
      const { operator_name, operator_id, bus_type } = commonState;
      const key = getRouteOperatorKey(commonState.src, commonState.dest, operator_name, operator_id, '', bus_type);

      let data = await getRouteOperatorTypePageData({ src: commonState.src, dest: commonState.dest, operator: operator_name, operatorId: operator_id, bus_type: bus_type });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateRouteData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getRouteClientDumpData(commonState.src, commonState.dest, key)
        pushDataToNewrelicFromServer(`mBusRouteOperatorTypePage=true&value=nodata&key=${key}`);
      }

      const { src, dest, dest_id, src_id, date } = data.data;

      let searchDateObj = {}
      let doj = null;

      const currentDateObj = format_dateObj({
        keyName: 'currentDate',
        value: dateformat(getDateObj(), 'yyyy-mm-dd')
      })

      if (date !== 'NA') {
        const queryDate = format_BusQueryDate(date);
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
      }

      if (date === 'NA' || searchDateObj['searchDateRaw'].getTime() <= currentDateObj['currentDateRaw'].getTime()) {
        doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
      }

      if (data && data.data && Object.keys(data.data).length && data.data.bus_data) {
        const {
          buses,
          operators,
          popular_filters,
          bp_dict,
          dp_dict,
          route_logic,
          ps,
          other_buses,
          other_operators
        } = data.data.bus_data as ISRPBusData;

        const {
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          amenities,
          operatorsList,
          popularFilters,
          isRouteEnable,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          otherPrivateAvailableBuses,
          otherRTCBuses
        } = getCategoryData(operators, buses, journeyType, popular_filters, bp_dict, dp_dict, src_id, dest_id, route_logic, other_buses, other_operators);

        if (data.data && data.data?.src_dump) {
          pushDataToNewrelicFromServer(`mBusRouteOperatorPage=true&value=dump&key=${src}_${dest}`);
        }

        return [updateRouteData(data), updateJourneyParamsSEO({
          src: src,
          dest: dest,
          src_vid: src_id,
          dest_vid: dest_id,
          doj: doj,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: src,
          dest_name: dest,
          operator_id: data.data.operatorId,
          operator_name: data.data.operatorName

        }), updateSRPBusData({
          data: data.data.bus_data,
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          operatorsList,
          amenities,
          popularFilters,
          isRouteEnable,
          ps,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          dumpData: data.data?.src_dump,
          bpdpData: data.data.bp_dp_data && Object.keys(data.data.bp_dp_data).length ? data.data.bp_dp_data : {},
          otherPrivateAvailableBuses,
          otherRTCBuses

        })];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    enableAdtech: true,
    fillStoreWaitTime: 10000,
    toBeCached: false,
    mongoCache: true,
    enableVWO: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const { src, dest, operator, operatorId, bus_type } = params;
        return getRouteOperatorKey(src, dest, operator, operatorId, '', bus_type);
      },
      mongoOptions: {
        baseURL: `${__ENV_CONFIG__.__DEPOT__}/apis/v1/seo_cache_data/`,
        template: 'route_operator_type',
        flavour: 'mobile'
      }
    },
  },
  {
    path: [
      '/bus/:operator-buses-from-:src-to-:dest-online-booking:operatorId?/',
    ],
    component: RouteOperatorRespPage,
    key: 'RouteOperatorRespPage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      const { src, dest, operator, operatorId } = params;
      dispatch(updateJourneyParamsSEO({
        src: src,
        dest: dest,
        src_vid: '',
        dest_vid: '',
        doj: '',
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        operator_name: operator,
        operator_id: operatorId.replace("-", "")
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // TODO to check for redirection
      const redirectUrl = redirection(state?.routePage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const journeyType: string = commonState.journeyType;
      const { operator_name, operator_id } = commonState;
      const key = getRouteOperatorKey(commonState.src, commonState.dest, operator_name, operator_id, '');

      let data = await getRouteOperatorPageData({ src: commonState.src, dest: commonState.dest, operator: operator_name, operatorId: operator_id });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateRouteData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getRouteClientDumpData(commonState.src, commonState.dest, key)
        pushDataToNewrelicFromServer(`mBusRouteOperatorPage=true&value=nodata&key=${key}`);
      }

      const { src, dest, dest_id, src_id, date } = data.data;

      let searchDateObj = {}
      let doj = null;
      const currentDateObj = format_dateObj({
        keyName: 'currentDate',
        value: dateformat(getDateObj(), 'yyyy-mm-dd')
      })

      if (date !== 'NA') {
        const queryDate = format_BusQueryDate(date);
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
      }

      if (date === 'NA' || searchDateObj['searchDateRaw'].getTime() <= currentDateObj['currentDateRaw'].getTime()) {
        doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
      }


      if (data && data.data && Object.keys(data.data).length && data.data.bus_data) {

        const {
          buses,
          operators,
          popular_filters,
          bp_dict,
          dp_dict,
          route_logic,
          ps,
          other_buses,
          other_operators
        } = data.data.bus_data as ISRPBusData;
        const {
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          amenities,
          operatorsList,
          popularFilters,
          isRouteEnable,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          otherPrivateAvailableBuses,
          otherRTCBuses

        } = getCategoryData(operators, buses, journeyType, popular_filters, bp_dict, dp_dict, src_id, dest_id, route_logic, other_buses, other_operators);

        if (data.data?.src_dump) {
          pushDataToNewrelicFromServer(`mBusRouteOperatorPage=true&value=dump&key=${src}_${dest}`);
        }

        return [updateRouteData(data), updateJourneyParamsSEO({
          src: src,
          dest: dest,
          src_vid: src_id,
          dest_vid: dest_id,
          doj: doj,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: src,
          dest_name: dest,
          operator_id: data.data.operatorId,
          operator_name: data.data.operatorName

        }), updateSRPBusData({
          data: data.data.bus_data,
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          operatorsList,
          amenities,
          popularFilters,
          isRouteEnable,
          ps,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          dumpData: data.data?.src_dump,
          bpdpData: data.data.bp_dp_data && Object.keys(data.data.bp_dp_data).length ? data.data.bp_dp_data : {},
          otherPrivateAvailableBuses,
          otherRTCBuses

        })];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    enableAdtech: true,
    fillStoreWaitTime: 10000,
    toBeCached: false,
    mongoCache: true,
    enableVWO: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const { src, dest, operator, operatorId } = params;
        return getRouteOperatorKey(src, dest, operator, operatorId, '');
      },
      mongoOptions: {
        baseURL: `${__ENV_CONFIG__.__DEPOT__}/apis/v1/seo_cache_data/`,
        template: 'route_operator',
        flavour: 'mobile'
      }
    },
  },
  {
    path: [
      '/bus/:type-buses-:city-book-online/',
    ],
    component: CityCategoryRespPage,
    key: 'CityCategoryRespPage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: '',
        dest: params.city,
        src_vid: '',
        dest_vid: '',
        doj: '',
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        filterStr: params.type
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // TODO to check for redirection
      const redirectUrl = redirection(state?.routePage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { dest, filterStr } = commonState
      let key = getCityCategoryKey(dest, filterStr, '');
      let data = await getCityCategoryPageData({ city: dest, type: filterStr });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateCityData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getCityClientDumpData(dest, key);
        pushDataToNewrelicFromServer(`mBusCityCategoryPage=true&value=nodata&key=${key}`);
      }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateCityData(data)];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: true,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: false,
    enableAdtech: true,
    mongoCache: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCityCategoryKey(params.city, params.type, '');
      },
      mongoOptions: {
        baseURL: `${__ENV_CONFIG__.__DEPOT__}/apis/v1/seo_cache_data/`,
        template: 'city_category',
        flavour: 'mobile'
      }
    },
  },
  {
    path: [
      '/bus/:type-buses-:city-book-gi-online/',
    ],
    component: CityCategoryRespPage,
    key: 'CityCategoryRespPage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: '',
        dest: params.city,
        src_vid: '',
        dest_vid: '',
        doj: '',
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        filterStr: params.type
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // GI
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { dest, filterStr } = commonState
      const key = getCityCategoryKey(dest, filterStr, 'gi');

      let data = await getCityCategoryPageData({ city: dest, type: filterStr });

      if (!data || !data.status || data.error) {
        data = getCityClientDumpData(dest, key);
        pushDataToNewrelicFromServer(`mBusCityCategoryPage=true&value=nodata&key=${key}`);
      }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateCityData(data)];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: true,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: false,
    enableAdtech: false,
    mongoCache: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCityCategoryKey(params.city, params.type, 'gi')
      },
      mongoOptions: {
        baseURL: `${__ENV_CONFIG__.__DEPOT__}/apis/v1/seo_cache_data/`,
        template: 'city_category',
        flavour: 'mobile'
      }
    },
  },
  {
    path: [
      '/bus/:src-to-:dest-bus-gi-tickets/',
    ],
    component: RouteGIRespPage,
    key: 'RouteGIRespPage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: params.src,
        dest: params.dest,
        src_vid: '',
        dest_vid: '',
        doj: '',
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: ''
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // GI
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const journeyType: string = commonState.journeyType;

      let data = await getRoutePageData({ src: commonState.src, dest: commonState.dest });
      let key = `${commonState.src}-to-${commonState.dest}-bus-tickets`

      if (!data || !data.status || data.error) {
        data = getRouteClientDumpData(commonState.src, commonState.dest, key)
        pushDataToNewrelicFromServer(`mBusRoutePage=true&value=nodata&key=${key}`);
      }
      const { src, dest, dest_id, src_id, date } = data.data;
      let searchDateObj = {}
      let doj = null;
      const currentDateObj = format_dateObj({
        keyName: 'currentDate',
        value: dateformat(getDateObj(), 'yyyy-mm-dd')
      })

      if (date !== 'NA') {
        const queryDate = format_BusQueryDate(date);
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
      }
      if (date === 'NA' || searchDateObj['searchDateRaw'].getTime() <= currentDateObj['currentDateRaw'].getTime()) {
        doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
      }

      if (data && data.data && Object.keys(data.data).length && data.data.bus_data) {

        const {
          buses,
          operators,
          popular_filters,
          bp_dict,
          dp_dict,
          route_logic,
          ps
        } = data.data.bus_data as ISRPBusData;
        const {
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          amenities,
          operatorsList,
          popularFilters,
          isRouteEnable,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,

        } = getCategoryData(operators, buses, journeyType, popular_filters, bp_dict, dp_dict, src_id, dest_id, route_logic);

        if (data.data && data.data?.src_dump) {
          pushDataToNewrelicFromServer(`mBusRoutePage=true&value=dump&key=${src}_${dest}`);
        }

        return [updateRouteData(data), updateJourneyParamsSEO({
          src: src,
          dest: dest,
          src_vid: src_id,
          dest_vid: dest_id,
          doj: doj,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: src,
          dest_name: dest

        }), updateSRPBusData({
          data: data.data.bus_data,
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          operatorsList,
          amenities,
          popularFilters,
          isRouteEnable,
          ps,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          dumpData: data.data?.src_dump,
          bpdpData: data.data.bp_dp_data && Object.keys(data.data.bp_dp_data).length ? data.data.bp_dp_data : {}

        })];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    enableAdtech: false,
    toBeCached: true,
    enableVWO: false,
    disbaleExternalDependency: true,
    enableRespCSS: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCachingKey(params.src, params.dest, "", "gikey", "route")
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [
      '/bus/:operator-bus-gi-booking:operatorId?/',
    ],
    component: OperatorRespPage,
    key: 'OperatorRespPage',
    onServerInit: () => {
    },

    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: '',
        dest: '',
        src_vid: '',
        dest_vid: '',
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        operator_name: params.operator,
        operator_id: params.operatorId || ''
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // GI
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { operator_name, operator_id } = commonState;
      let key = `${operator_name}-bus-booking${operator_id}`;

      let data = await getOperatorPageData({
        operatorName: commonState.operator_name,
        operatorId: commonState.operator_id
      });

      if (!data || !data.status || data.error) {
        data = getOperatorClientDumpData(operator_name, operator_id, key);
        pushDataToNewrelicFromServer(`mBusOperatorPage=true&value=nodata&key=${key}`);
      }

      if (data && data.data && Object.keys(data.data).length) {
        return [updateOperatorData(data)];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: false,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    disbaleExternalDependency: true,
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getOperatorKey(params.operator, params.operatorId, "", "gikey");
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [
      '/bus/:src-to-:dest-:type?-bus-ticket-gi-booking/',
    ],
    component: RouteCategoryRespPage,
    key: 'RouteCategoryRespPage',
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        src: params.src,
        dest: params.dest,
        src_vid: '',
        dest_vid: '',
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: params.src,
        dest_name: params.dest,
        filterStr: params.type
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // GI
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { filterStr, journeyType } = commonState;
      const key = `${commonState.src}-to-${commonState.dest}-${filterStr}-bus-ticket-gi-booking`;

      let data = await getRouteCategoryPageData({ src: commonState.src, dest: commonState.dest, slug: filterStr });

      if (data && data?.data && data.data?.redirect_to) {
        return [updateRouteData(data)];
      }

      if (!data || !data.status || data.error) {
        data = getRouteClientDumpData(commonState.src, commonState.dest, key)
        pushDataToNewrelicFromServer(`mBusRouteCategoryPage=true&value=nodata&key=${key}`);
      }

      if (data && data?.data && data?.data?.src_dump) {
        pushDataToNewrelicFromServer(`mBusRouteCategoryPage=true&value=dump&key=${key}`);
      }

      const { src, dest, dest_id, src_id, date } = data.data;
      let searchDateObj = {}
      let doj = null;

      const currentDateObj = format_dateObj({
        keyName: 'currentDate',
        value: dateformat(getDateObj(), 'yyyy-mm-dd')
      })

      if (date !== 'NA') {
        const queryDate = format_BusQueryDate(date);
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
      }

      if (date === 'NA' || searchDateObj['searchDateRaw'].getTime() <= currentDateObj['currentDateRaw'].getTime()) {
        doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
      }

      if (data && data.data && Object.keys(data.data).length && data.data.bus_data) {
        const {
          buses,
          operators,
          popular_filters,
          bp_dict,
          dp_dict,
          route_logic,
          ps,
          other_buses
        } = data.data.bus_data as ISRPBusData;
        const {
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          amenities,
          operatorsList,
          popularFilters,
          isRouteEnable,
          otherPrivateAvailableBuses,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          primaryFiltersInfo

        } = getCategoryData(operators, buses, journeyType, popular_filters, bp_dict, dp_dict, src_id, dest_id, route_logic, other_buses);

        return [updateRouteData(data), updateJourneyParamsSEO({
          src: src,
          dest: dest,
          src_vid: src_id,
          dest_vid: dest_id,
          doj: doj,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: src,
          dest_name: dest,
          filterStr: ''


        }), updateSRPBusData({
          data: data.data.bus_data,
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          operatorsList,
          amenities,
          popularFilters,
          isRouteEnable,
          ps,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          primaryFiltersInfo,
          dumpData: data.data?.src_dump,
          bpdpData: data.data.bp_dp_data && Object.keys(data.data.bp_dp_data).length ? data.data.bp_dp_data : {},
          otherPrivateAvailableBuses

        })];
      }


    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: false,
    enableAdtech: false,
    enableVWO: false,
    mongoCache: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCachingKey(params.src, params.dest, params.type, "gikey");
      },
      mongoOptions: {
        baseURL: `${__ENV_CONFIG__.__DEPOT__}/apis/v1/seo_cache_data/`,
        template: 'sector_category',
        flavour: 'mobile'
      }
    },
  },
  {
    path: [
      '/bus/:operator-buses-from-:src-to-:dest-online-gi-booking:operatorId?/',
    ],
    component: RouteOperatorRespPage,
    key: 'RouteOperatorRespPage',
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      const { src, dest, operator, operatorId } = params;
      dispatch(updateJourneyParamsSEO({
        src: src,
        dest: dest,
        src_vid: '',
        dest_vid: '',
        doj: '',
        journeyType: 'onw',
        flavour: 'mweb',
        dojObj: getDateObj(),
        src_name: '',
        dest_name: '',
        operator_name: operator,
        operator_id: operatorId.replace("-", "")
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      // GI
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const journeyType: string = commonState.journeyType;
      let data = null;
      let key = '';
      {
        const { src, dest, operator_name, operator_id } = commonState;
        key = getRouteOperatorKey(src, dest, operator_name, operator_id, '');
        data = await getRouteOperatorPageData({ src, dest, operator: operator_name, operatorId: operator_id });

        if (!data || !data.status || data.error) {
          data = getRouteClientDumpData(commonState.src, commonState.dest, key)
          pushDataToNewrelicFromServer(`mBusRouteOperatorPage=true&value=nodata&key=${key}`);
        }
      }
      const { src, dest, dest_id, src_id, date } = data.data;

      let searchDateObj = {}
      let doj = null;
      const currentDateObj = format_dateObj({
        keyName: 'currentDate',
        value: dateformat(getDateObj(), 'yyyy-mm-dd')
      })

      if (date !== 'NA') {
        const queryDate = format_BusQueryDate(date);
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
      }

      if (date === 'NA' || searchDateObj['searchDateRaw'].getTime() <= currentDateObj['currentDateRaw'].getTime()) {
        doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
        searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
      }

      if (data && data.data && Object.keys(data.data).length && data.data.bus_data) {

        const {
          buses,
          operators,
          popular_filters,
          bp_dict,
          dp_dict,
          route_logic,
          ps,
          other_buses,
          other_operators
        } = data.data.bus_data as ISRPBusData;
        const {
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          amenities,
          operatorsList,
          popularFilters,
          isRouteEnable,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          otherPrivateAvailableBuses,
          otherRTCBuses

        } = getCategoryData(operators, buses, journeyType, popular_filters, bp_dict, dp_dict, src_id, dest_id, route_logic, other_buses, other_operators);

        if (data.data && data.data?.src_dump) {
          pushDataToNewrelicFromServer(`mBusRouteOperatorPage=true&value=dump&key=${src}_${dest}`);
        }

        return [updateRouteData(data), updateJourneyParamsSEO({
          src: src,
          dest: dest,
          src_vid: src_id,
          dest_vid: dest_id,
          doj: doj,
          journeyType: 'onw',
          flavour: 'mweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name: src,
          dest_name: dest,
          operator_id: data.data.operatorId,
          operator_name: data.data.operatorName

        }), updateSRPBusData({
          data: data.data.bus_data,
          rtcBuses,
          privateAvailableBuses,
          privateSoldOutBuses,
          dpList,
          bpList,
          operatorsList,
          amenities,
          popularFilters,
          isRouteEnable,
          ps,
          primaryFiltersInfo,
          isOTGApplicable,
          isGosafe,
          isLiveTracking,
          isRedDeal,
          dumpData: data.data?.src_dump,
          bpdpData: data.data.bp_dp_data && Object.keys(data.data.bp_dp_data).length ? data.data.bp_dp_data : {},
          otherPrivateAvailableBuses,
          otherRTCBuses
        })];
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    webType: 'mobile',
    enableAdtech: false,
    fillStoreWaitTime: 10000,
    toBeCached: false,
    mongoCache: false,
    enableVWO: false,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const { src, dest, operator, operatorId } = params;
        return getRouteOperatorKey(src, dest, operator, operatorId, "gikey");
      },
      mongoOptions: {
        baseURL: `${__ENV_CONFIG__.__DEPOT__}/apis/v1/seo_cache_data/`,
        template: 'route_operator',
        flavour: 'mobile'
      }
    },
  },
  {
    path: [OPERATOR_DIRECTORY_URL],
    component: DirectoryPage,
    key: OPERATOR_DIRECTORY_PAGE,
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      const pageNo = new URLSearchParams(searchString).get("pg");
      dispatch(updateJourneyParamsSEO({
        pageNumber: pageNo ?? 1,
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        dojObj: getDateObj(),
        pageType: OPERATOR_DIRECTORY_PAGE,
      }))
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.DirectoryPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      let data = await getOperatorDirPageData({ page: commonState.pageNumber });

      if (data && data.data && Object.keys(data.data).length) {
        return [updateDirectoryData(data)];
      }
    },
    criticalApiPreFetch: () => { },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => { },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: true,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const pageNo = new URLSearchParams(searchString).get("pg");
        return getDirKey(pageNo, "operator");
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [ROUTES_DIRECTORY_URL,],
    component: DirectoryPage,
    key: ROUTES_DIRECTORY_PAGE,
    onServerInit: () => {
    },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      const pageNo = new URLSearchParams(searchString).get("pg");
      dispatch(updateJourneyParamsSEO({
        pageNumber: pageNo ?? 1,
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        dojObj: getDateObj(),
        pageType: ROUTES_DIRECTORY_PAGE,
      }))
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.DirectoryPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      let data = await getRoutesDirPageData({ page: commonState.pageNumber });

      if (data && data.data && Object.keys(data.data).length) {
        return [updateDirectoryData(data)];
      }
    },
    criticalApiPreFetch: () => { },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => { },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: true,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const pageNo = new URLSearchParams(searchString).get("pg");
        return getDirKey(pageNo, "routes");
      },
      redisConfig: redisConfig,
    },
  }, {
    path: [CATEGORY_URL,],
    component: CategoryPage,
    key: 'CategoryPage',
    onServerInit: () => { },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        dojObj: getDateObj(),
        pageType: params.category,
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.CategoryPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { pageType } = commonState;
      const key = `${pageType}-bus-services`;

      let data = await getCategoryPageData({ pageType });

      if (data && data?.data) {
        return [updateCategoryData(data)];
      }

      if (!data || !data.status || data.error) {
        pushDataToNewrelicFromServer(`mBusCategoryPage=true&value=nodata&key=${key}`);
      }
    },
    criticalApiPreFetch: () => {
    },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {
    },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: true,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCachingKey(params.category, "", "", "", "category");
      },
      redisConfig: redisConfig,
    },
  },
  {
    path: [STAND_URL,],
    component: StandPage,
    key: 'StandPage',
    onServerInit: () => { },
    populateStoreFromUrl: ({ params, searchString }, dispatch) => {
      dispatch(updateJourneyParamsSEO({
        doj: dateformat(getDateObj(), 'yyyymmdd'),
        dojObj: getDateObj(),
        stand: params.stand,
      })
      )
    },
    actionsBeforeRenderOnServer: ({ state, params, searchString }) => {
      const redirectUrl = redirection(state?.StandPage);
      if (redirectUrl) {
        return { status: 301, redirectUrl }
      }
    },
    fillStoreOnServer: async ({ state, localData }) => {
      const commonState = state.BusCommonSEO;
      const { stand } = commonState;
      const key = `${stand}-bus-stand`;

      let data = await getStandPageData({ stand });

      if (data && data?.data) {
        return [updateStandData(data)];
      }

      if (!data || !data.status || data.error) {
        pushDataToNewrelicFromServer(`mStandPage=true&value=nodata&key=${key}`);
      }
    },
    criticalApiPreFetch: () => { },
    toBeSSRed: true,
    isModal: false,
    fillStore: () => { },
    responseHeader: {},
    isHotjarEnabled: false,
    exact: true,
    showFooter: true,
    enableAdtech: true,
    webType: 'mobile',
    fillStoreWaitTime: 10000,
    toBeCached: true,
    disbaleExternalDependency: true,
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        return getCachingKey(params.stand, "", "", "", "stand");
      },
      redisConfig: redisConfig,
    },
  }
];
